import React from "react";
import Form from "../../components/forms/form";
import {dataForPlanType} from "../patients/dataForNewGroup";
import DropdownListForm from "../../components/forms/dropdownListForm";
import {AutomatedCampaignFilter, CampaignSetting} from "./dataForDesignCampaign";
import {AutomatedCampaignType} from "./dataForActiveCampaign";

interface IProps {
    setting: CampaignSetting,
    onChange: (filter: AutomatedCampaignFilter, isValid: boolean) => void
}

export default function CampaignFilterPage({setting, onChange}: IProps) {
    const fromAge = setting.filter.fromAge
    const toAge = setting.filter.toAge

    const checkNumber = (age: string) => /^(0|[1-9][0-9]*)$/.test(age)
    const checkAge = (from: string, to: string) => {
        if (checkNumber(from) &&
            checkNumber(to) && parseInt(from, 10) >= parseInt(to, 10)) {
            return "To age must be greater than from age."
        }
        return ""
    }
    const errMsgForFromAge = fromAge.length && !checkNumber(fromAge) ? "Invalid from age" : ""
    const errMsgForToAge = setting.filter.toAge.length && !checkNumber(setting.filter.toAge) ? "Invalid to age" : ""
    const $ageForms = (
        <div className={"w-full"}>
            <p className={"relative text-gray-1 text-sm text-left"}>Age</p>
            <div className={"flex flex-row"}>
                <div className={"flex-1 h-full"}>
                    <Form errMsg={errMsgForFromAge} placeholder={"From"} value={fromAge} onChangeText={(text) => {
                        onChange && onChange({
                            ...setting.filter,
                            fromAge: text,
                        }, !checkAge(text, toAge).length)
                    }} title={""}/>
                </div >

                <div className={"min-h-full w-2 mx-2"}>
                    <div className={"h-0.5 w-2 bg-black mt-6"}/>
                </div>
                <div className={"flex-1"}>
                    <Form errMsg={errMsgForToAge} placeholder={"To"} value={setting.filter.toAge} onChangeText={(text) => {
                        onChange && onChange({
                            ...setting.filter,
                            toAge: text,
                        }, !checkAge(fromAge, text).length)
                    }} title={""}/>
                </div>
            </div>
        </div>
    )

    const $planTypeForms = (
        <DropdownListForm title={"Plan Type"} id={setting.filter.planType} data={dataForPlanType} onChange={(id) => {
            onChange && onChange({
                ...setting.filter,
                planType: id,
            }, true)
        }} />
    )

    const $appointmentReminderFilter = (setting.automatedCampaignType === AutomatedCampaignType.appointment ?
        <div className={"w-full flex grid grid-cols-2 gap-x-2"}>
            {$ageForms}
            {$planTypeForms}
        </div> : null
    )

    const $birthdayReminderFilter = (setting.automatedCampaignType === AutomatedCampaignType.birthday ?
        <div className={"w-full flex"}>
            {$ageForms}
        </div> : null
    )

    const errMsgForAge = checkAge(fromAge, toAge)
    const $errMsg = errMsgForAge.length ? <p className="text-red-500 text-sm italic">{errMsgForAge}</p> : null
    return (
        <div className={"flex flex-col space-y-1"}>
            {$appointmentReminderFilter}
            {$birthdayReminderFilter}
            {$errMsg}
        </div>
    )
}
